define([
    'uiComponent',
    'Magento_Customer/js/customer-data',
    'Lfi_Customer/js/model/state'
], (Component, customerData, customerState) => {
    'use strict';

    return Component.extend({
        initialize: function () {
            this._super();

            /**
             * While localstorage is a great way to keep and read customer data
             * Far too many grubby modules can control the data of the customer
             * object stored there (like Klaviyo). For this reason, we need to
             * persist our own data key-value pair.
             */
            customerData.get('customer').subscribe(this.persistCustomerData.bind(this));
        },

        persistCustomerData: function (data) {
            if (data.hasOwnProperty('firstname') && data.firstname.length) {
                customerState.setPersistentCustomerFirstname(data.firstname);
            }
            if (data.hasOwnProperty('email') && data.email.length) {
                customerState.setPersistentCustomerEmail(data.email);
            }
        }
    });
});
